export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-gray-800 to-gray-900 py-16 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-teal-600/10 rounded-3xl transform -rotate-12"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-amber-500/10 rounded-3xl transform rotate-12"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-3xl p-12 mb-8">
          <div className="grid md:grid-cols-4 gap-12">
            {/* Column 1 - Company Info */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/3a10202548e2a70a8adbcf19d852ef15.png" 
                  alt="Nam Phát Logo" 
                  className="h-10 w-auto"
                />
                <div>
                  <h3 className="text-amber-400 text-lg font-bold">Nam Phát</h3>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                Đơn vị thu mua phế liệu uy tín, chuyên nghiệp với hơn 15 năm kinh nghiệm. Phục vụ 24/7 - Giá cao - Thanh toán ngay.
              </p>
              <div className="text-gray-400 text-xs">
                <p>Giờ làm việc: 24/7</p>
                <p className="mt-1 text-amber-400 font-medium">Luôn sẵn sàng phục vụ</p>
              </div>
            </div>

            {/* Column 2 - Services */}
            <div>
              <h4 className="text-white font-bold text-sm uppercase mb-4">DỊCH VỤ</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Thu Mua Sắt Thép
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Thu Mua Nhôm
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Thu Mua Đồng
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Thu Mua Inox
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Thu Mua Máy Móc
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 - Links */}
            <div>
              <h4 className="text-white font-bold text-sm uppercase mb-4">LIÊN KẾT</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#about" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Giới Thiệu
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Bảng Giá
                  </a>
                </li>
                <li>
                  <a href="#process" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Quy Trình
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Liên Hệ
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    Tuyển Dụng
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 4 - Quick Contact */}
            <div>
              <h4 className="text-white font-bold text-sm uppercase mb-4">LIÊN HỆ NHANH</h4>
              <div className="space-y-3">
                <a href="tel:0968947136" className="block bg-amber-500 hover:bg-amber-600 text-gray-900 px-5 py-3 rounded-xl text-sm font-bold transition-all whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-fill text-base"></i>
                  </div>
                  0968.947.136
                </a>
                <a href="https://zalo.me/0968947136" className="block bg-blue-500 hover:bg-blue-600 text-white px-5 py-3 rounded-xl text-sm font-bold transition-all whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-chat-4-fill text-base"></i>
                  </div>
                  Chat Zalo
                </a>
                <div className="text-gray-400 text-xs mt-4">
                  <p className="mb-1">Email: contact@namphat.vn</p>
                  <p>Địa chỉ: Khu công nghiệp, Việt Nam</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Công Ty TNHH Phế Liệu Nam Phát. All rights reserved. | 
              <a href="#" className="hover:text-amber-400 transition-colors ml-1 cursor-pointer">Chính sách bảo mật</a> | 
              <a href="#" className="hover:text-amber-400 transition-colors ml-1 cursor-pointer">Điều khoản sử dụng</a>
            </div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-facebook-fill text-white text-lg"></i>
                </div>
              </a>
              <a href="https://zalo.me/0968947136" className="w-10 h-10 bg-gray-700 hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-chat-4-fill text-white text-lg"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}